import React from 'react';
import { Select } from '@mantine/core';
import { ReactComponent as DownArrow } from 'assets/icons/downArrow.svg';
import { ReactComponent as Filter } from 'assets/icons/filterIcon.svg';
const Filters = ({ mailFilter, setMailFilter }) => {
  return (
    <div className='flex gap-4 2xl:gap-5 3xl:gap-6 justify-between items-center '>
      <Select
        value={mailFilter}
        defaultValue='all'
        icon={<Filter className='w-4 h-4 2xl:w-4 2xl:h-4 3xl:w-5 3xl:h-5' />}
        rightSection={
          <DownArrow className='w-3 h-4 2xl:w-4 2xl:h-5 3xl:w-5 3xl:h-6' />
        }
        styles={{ rightSection: { pointerEvents: 'none' } }}
        //onChange={setFilterValue}

        data={[
          { value: 'all', label: 'All' },
          { value: 'read', label: 'Read' },
          { value: 'unread', label: 'Unread' },
        ]}
        onChange={(e) => setMailFilter(e)}
        classNames={{
          wrapper: 'border-primary border-b',
          input:
            'w-lg border-none  font-light text-000000 text-xs 2xl:w-xl 2xl:text-lg 3xl:w-2xl 3xl:text-xl',
        }}
      />

      {/* 
        <Select
          disabled
          defaultValue='low'
          icon={<Filter className='w-4 h-4 2xl:w-4 2xl:h-4 3xl:w-5 3xl:h-5' />}
          rightSection={
            <DownArrow className='w-3 h-4 2xl:w-4 2xl:h-5 3xl:w-5 3xl:h-6' />
          }
          styles={{ rightSection: { pointerEvents: 'none' } }}
          //onChange={setFilterValue}
          data={[
            { value: 'low', label: 'Low' },
            { value: 'medium ', label: 'Medium' },
            { value: 'high', label: 'High' },
          ]}
          classNames={{
            wrapper: 'border-primary border-b',
            input:
              'w-lg border-none font-light text-000000 text-xs 2xl:text-lg 2xl:w-xl 3xl:w-2xl 3xl:text-xl',
          }}
        /> */}
      {/*  <Select
          disabled
          defaultValue='5'
          icon={<Filter className='w-4 h-4 2xl:w-4 2xl:h-4 3xl:w-5 3xl:h-5' />}
          rightSection={
            <DownArrow className='w-3 h-4 2xl:w-4 2xl:h-5 3xl:w-5 3xl:h-6' />
          }
          rightSectionWidth={10}
          styles={{ rightSection: { pointerEvents: 'none' } }}
          //onChange={setFilterValue}
          data={[
            { value: '1', label: 'January' },
            { value: '2', label: 'February' },
            { value: '3', label: 'March' },
            { value: '4', label: 'April' },
            { value: '5', label: 'May' },
            { value: '6', label: 'June' },
            { value: '7', label: 'July' },
            { value: '8', label: 'August' },
            { value: '9', label: 'September' },
            { value: '10', label: 'October' },
            { value: '11', label: 'Noverber' },
            { value: '12', label: 'december' },
          ]}
          classNames={{
            wrapper: 'border-primary border-b',
            input:
              'w-lg border-none font-light text-000000 text-xs 2xl:text-lg 2xl:w-xl 3xl:w-2xl 3xl:text-xl',
          }}
        /> */}
    </div>
  );
};

export default Filters;
